import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import Contact from "./Contact";
import "../../style/style.scss";
import { Link } from "react-router-dom";
import logo from "../../assets/PNG/KonnectxLogoWhite.png";
import { routesPages } from "../../config/route";
import { Routes } from "../../config/Routes";

const Footer = ({ refes }) => {
  const showContact = routesPages.find((item) => (window.location.pathname.toString()) === item);

  return (
    <>
      {showContact && <Contact refs={refes} />}
      <footer className="page-footer text-center font-small info-color-dark background">
        <div className="rgba-stylish-strong">
          <div className=""></div>
          <div>
            <img className="footer-logo mb-3" src={logo} alt="logo" />
          </div>
          <div className="footer-copywright  background padding-mange">
            All product and company names are registered ® of their respective
            holders. <br></br>
            All Rights Reserved © {new Date().getFullYear()} KonnectX.com
          </div>
          <hr className="mb-0" />
          <div className="two-grid ">
            <div className="pages-link">
              <ul>
                <li>
                  <Link
                    to="/terms-and-conditions"
                    target="_blank"
                    style={{ color: "white" }}
                    className="link"
                  >
                    Terms and Conditions
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy-policy"
                    target="_blank"
                    style={{ color: "white" }}
                    className="link"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cookies-policy"
                    target="_blank"
                    style={{ color: "white" }}
                    className="link"
                  >
                    Cookies Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/data-policy"
                    target="_blank"
                    style={{ color: "white" }}
                    className="link"
                  >
                    Data Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <ul>
                <li className="icon-footer-adjustment">
                  <Link to="https://www.facebook.com/konnectx.us" target="_blank">
                    <FaFacebookF className="mr-3 p-" size={15} color="white" />
                  </Link>
                </li>
                <li className="icon-footer-adjustment">
                  <Link to="https://instagram.com/konnectx.us" target="_blank">
                    <FaInstagram className="mr-3" size={15} color="white" />
                  </Link>
                </li>
                <li className="icon-footer-adjustment">
                  <Link to="https://twitter.com/konnect_X" target="_blank">
                    <FaTwitter className="mr-3" size={15} color="white" />
                  </Link>
                </li>
                <li className="icon-footer-adjustment">
                  <Link to="https://www.linkedin.com/company/konnectx/" target="_blank">
                    <FaLinkedin className="mr-3" size={15} color="white" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
